import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// import "@/assets/style/scss/main.scss";
// import "./assets/style/css/font.css";
import "react-toastify/dist/ReactToastify.css";
import "react-form-builder2/dist/app.css";
import GlobalStyles from "./components/styledFonts/GlobalStyles";
import { Provider } from "react-redux";
// import "./index.css";
window.app2Url = "http://localhost:3002";

import store from "./store";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <GlobalStyles />
    <App />
  </Provider>
);
